import { render, staticRenderFns } from "./ProjectItems.vue?vue&type=template&id=971df334&scoped=true&"
import script from "./ProjectItems.vue?vue&type=script&lang=js&"
export * from "./ProjectItems.vue?vue&type=script&lang=js&"
import style0 from "./ProjectItems.vue?vue&type=style&index=0&id=971df334&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "971df334",
  null
  
)

export default component.exports